import { useUserStore } from '@/config/store/userStore'
import { isModuleActive } from '@/services/application'

const moduleId = 12

// Profiles saved before `modules.survey` existed fall back on the module access of the profile:
// admin module = manage + settings, individual module = answer (same rules as api/survey/access.js)
const getSurveyModule = (user) => {
  const hasModuleAccess = modules => !!modules?.find(m => m.moduleId === moduleId)?.isAccess
  const surveyModule = user?.profile?.modules?.survey
  const adminAccess = hasModuleAccess(user?.profile?.adminModules)
  const individualAccess = hasModuleAccess(user?.profile?.resourceModules)

  return {
    isAccess: !!(surveyModule?.isAccess ?? (adminAccess || individualAccess)),
    manageAccess: !!(surveyModule?.manageAccess ?? adminAccess),
    mySurveysAccess: !!(surveyModule?.mySurveysAccess ?? (adminAccess || individualAccess)),
    settingsAccess: !!(surveyModule?.settingsAccess ?? adminAccess),
  }
}

export const canUserAccessModule = (user = useUserStore().user) => {
  if (!user) return false
  const isFirmAccess = isModuleActive(user.firm, moduleId)
  return isFirmAccess && getSurveyModule(user).isAccess
}

export const guardSurveyAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = canUserAccessModule(user)
  return canAccess || { name: 'Home' }
}

export const guardSurveyManage = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return getSurveyModule(user).manageAccess || { name: 'Home' }
}

export const guardMySurveys = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return getSurveyModule(user).mySurveysAccess || { name: 'Home' }
}

export const guardSurveySettingsAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return getSurveyModule(user).settingsAccess || { name: 'Home' }
}

// The page a user lands on: the surveys to follow for those who manage them, their own otherwise
export const getSurveyHome = () => (guardSurveyManage() === true ? { name: 'Surveys' } : { name: 'MySurveys' })
